import loadJS from 'load-js'

import { IntercomLauncherClass } from '../constants/Intercom'
import { intercomAppId, isLocalEnv } from './env'

window.intercomSettings = {
    app_id: intercomAppId,
    hide_default_launcher: true,
    custom_launcher_selector: `.${IntercomLauncherClass}`
}

export const dependencies = [
    {
        text: (
            `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/zd6qmzpv';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`
        )
    },
    {
        // HubSpot
        text: (
            `(function(w,d,s,p,i){window.hsConversationsSettings=p;var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s);j.async=true;j.src='https://js.hs-scripts.com/'+i+'.js';
            f.parentNode.insertBefore(j,f);})(window,document,'script',{loadImmediately:false},5756448);`
        ),
        removeInLocalEnv: true
    },
    {
        // Dropbox
        url: 'https://www.dropbox.com/static/api/2/dropins.js',
        async: true
    },
    {
        // Google Tag Manager
        text: (
            `dataLayer=[];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5393TWM');`
        )
    },
    {
        // Calendly
        url: 'https://assets.calendly.com/assets/external/widget.js'
    }
]

export default function loadDependencies() {
    loadJS((isLocalEnv
        ? dependencies.filter(d => !d.removeInLocalEnv)
        : dependencies
    )).catch(err => console.warn('Fail on loading dependency', err))
}
